/**
 * pgc成功
 * 2017-12-6
 */
"use strict";
angular.module("successEnterpriseModule", [
    "successEnterpriseRouter", //路由
]).
controller("successEnterpriseCtrl", ["$scope", "Upload", "modalDialog", "$state", "httpService", '$element', '$validation', function($scope, Upload, modalDialog, $state, httpService, $element, $validation) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化参数
     */
    function initStatus() {
        $scope.status = {

        };
        $scope.data = {
            listData: [],
            isShowTipsC: false,
            textShow:true,//判断是否显示文字

        };
        $scope.info = {};
        initDropDownList();
    }
    /**
     * [initStatus description] 初始化数据
     */
    function initData() {
        getPicSizeLimit();
    }

    /**
     * [initDropDownList description] 初始下拉
     */
    function initDropDownList() {
        $scope.status.bankOptions = [{
            name: "选择开户银行",
            value: 0
        }, {
            name: "工商银行",
            value: 1,
        }, {
            name: "农业银行",
            value: 2,
        }, {
            name: "中国银行",
            value: 3,
        }, {
            name: "建设银行",
            value: 4,
        }, {
            name: "交通银行",
            value: 5,
        }, {
            name: "上海浦东发展银行",
            value: 6,
        }, {
            name: "兴业银行",
            value: 7,
        }, {
            name: "光大银行",
            value: 8,
        }, {
            name: "深圳发展银行",
            value: 9,
        }, {
            name: "民生银行",
            value: 10,
        }, {
            name: "中信银行",
            value: 11,
        }, {
            name: "招商银行",
            value: 12,
        }, {
            name: "广东发展银行",
            value: 13,
        }, {
            name: "华夏银行",
            value: 14,
        }];
        $scope.status.selectedBank = angular.copy($scope.status.bankOptions[0]);
        $scope.status.selectedBank.name = '请选择开户银行';
    }
    /**
     * [regularIf description] 判断是否显示正确图标
     * @return {[type]} [description]
     */
    $scope.regularIf = function(key, value) {
        switch (key) {
            case 1: //真实姓名
                $scope.isShowTipsA = false;
                $scope.data.isShowTipsAa = false;
                break;
            case 2: //银行卡号
                $scope.isShowTipsF = false;
                $scope.data.isShowTipsFf = false;
                break;
            case 3: //支付吧帐号
                $scope.isShowTipsG = false;
                $scope.data.isShowTipsGg = false;
        }
        $validation.validate($scope.changePwdFormOk[value]).success(function() {
            switch (key) {
                case 1:
                    $scope.data.isShowTipsAa = true;
                    break;
                case 2:
                    $scope.data.isShowTipsFf = true;
                    break;
                case 3:
                    $scope.data.isShowTipsGg = true;
                    break;
            }
        });
    };
    /**
     * [funciton description] 下拉框加样式
     * @return {[type]} [description]
     */
    $scope.selectData = function(key) {
        key.value == 0 ? $element.find('trs-single-select button span:first-child').removeClass('textColor') : $element.find('trs-single-select button span:first-child').addClass('textColor');
        $scope.data.isShowTipsC = key.value == 0 ? false : true;
    };
    /**
     * [changeHeadPortrait description]  更换头像
     * @param  {[type]} files    [description]
     * @param  {[type]} file     [description]
     * @param  {[type]} newFiles [description]
     * @return {[type]}          [description]
     */
    $scope.changeHeadPortrait = function(files, file, newFiles) {
        $scope.data.textShow=true;
        if (file.size > Number($scope.status.picSizeLimit) * 1024) {
            modalDialog.alertType("", "图片最大不能超过" + $scope.status.picSizeLimit + "KB!", "warning", "confirm");
            $element.find('.photoHead>div>span').click();
            return;
        }
        var typeData = file.type.split('/')[1];
        if (typeData != 'jpg' && typeData != 'jpeg' && typeData != 'png') {
            $element.find('.photoHead>div>span').click();
            modalDialog.success("您只能上传jpg,jpeg,png类型的文件", "success", false, function() {}, function() {}, '', 'getCodeSuccess');

            return;
        }
        var imgType = ['jpg', 'jpeg', 'png', 'bmp', 'gif'],
            fileType = newFiles[0].name.substr(newFiles[0].name.lastIndexOf('.') + 1).toLowerCase();
        if (imgType.indexOf(fileType) < 0) {
            modalDialog.alertType('格式不支持', '', 'warning', false);
            return;
        }
        if (newFiles) {
            $scope.status.changeHeader = true;
        }
        Upload.upload({
            url: "/mcnww/upload/image.do",
            headers:{requestToken:sessionStorage.getItem('requestToken')},
            data: {
                file: newFiles[0]
            },
        }).then(function(resp) {
            if (resp.data.success == false) {
                modalDialog.success(resp.data.message, "success", false, function() {}, function() {}, '', 'getCodeSuccess');
                return;
            }
            var time = new Date().getTime();
            $scope.photoCard = angular.globalConfig.pictureServer + resp.data.url + '?v=' + time;
            $scope.data.textShow=false;
            $scope.idNumberPic = resp.data.url;
            // modalDialog.success("身份证图片上传成功", "success", false, function() {}, function() {}, '', 'getCodeSuccess');
        });
    };
    /**
     * [cancel description]  以后再说
     * @param  {[type]}   [description]
     */
    $scope.cancel = function() {
        $state.go("index.homepage");
    };
    /**
     * [savePwd description]  保存
     * @param  {[type]}   [description]
     */
    $scope.savePwd = function() {
        $validation.validate($scope.changePwdFormOk).success(function() {
            $scope.info.bankName = $scope.status.selectedBank.value;
            $scope.info.idNumberPic = $scope.idNumberPic;
            httpService.http("/mcnww/web/user/pgcUpdate.do", $scope.info, "post").then(function(data) {
                // modalDialog.alertType("提交成功", "", "success", false, function() {});
                localStorage.clear();
                $state.go("index.homepage");
            });
        }).error(function() {
            angular.invalidPosition($scope.changePwdFormOk, $element);
        });

    };
    /**
     * [getPicSizeLimit description] 获取图片尺寸上限
     * @return {[type]} [description]
     */
    function getPicSizeLimit() {
        httpService.http("/mcnww/web/image/getImageSizelimit.do", "", "get").then(function(data) {
            $scope.status.picSizeLimit = data.message;
        });
    }
}]);